// extracted by mini-css-extract-plugin
export default {"authRequired":"AuthRequired_authRequired__bPBe6","authRequiredButtons":"AuthRequired_authRequiredButtons__xAn4D","authRequiredAboutLink":"AuthRequired_authRequiredAboutLink__j3d1u"};